"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MenuLink = void 0;
var _menuModule = _interopRequireDefault(require("@albelli/arc-3/lib/menu.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
var _parseurl = _interopRequireDefault(require("parseurl"));
var _react = _interopRequireWildcard(require("react"));
var _Icon = require("../Icon");
var _LogoutLink = require("./LogoutLink");
var _MenuContext = require("./MenuContext");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const MenuLink = _ref => {
  let {
    text,
    icon,
    href,
    secondary,
    showArrow,
    items,
    className,
    expanded,
    setExpanded,
    isLogout
  } = _ref;
  const [currentHost, setCurrentHost] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    setCurrentHost(window.location.hostname);
  }, []);
  const menuContext = (0, _MenuContext.useMenuContext)();
  const classes = (0, _classnames.default)({
    "link--color-dark-grey": !!secondary && !className,
    [_menuModule.default["arc3-menu__main__nav__button"]]: !!showArrow
  }, className);
  if (isLogout) {
    return /*#__PURE__*/_react.default.createElement(_LogoutLink.LogoutLink, {
      text: text,
      className: classes
    });
  }
  const onClick = e => {
    if (!href) return;

    //If the url is a MyAccount url we want to use react router instead of default anchor functionality.
    const parsedHref = (0, _parseurl.default)({
      url: href
    });
    if (currentHost === parsedHref.hostname && menuContext.onLocalNavigation) {
      e.preventDefault();
      //react router only needs what comes after the host
      menuContext.onLocalNavigation(parsedHref.path);
    }
  };
  const isExpandable = items && items.length;
  const expand = e => {
    if (isExpandable && setExpanded) {
      setExpanded(text);
      e.preventDefault();
    }
  };
  const collapse = e => {
    if (isExpandable && setExpanded) {
      setExpanded(expanded === text ? false : expanded);
      e.preventDefault();
    }
  };
  const toggleExpand = e => {
    if (isExpandable) {
      expanded !== text ? expand(e) : collapse(e);
    }
  };
  return /*#__PURE__*/_react.default.createElement("a", {
    className: classes,
    href: href,
    onMouseOver: expand,
    onMouseLeave: collapse,
    onTouchEnd: toggleExpand,
    onClick: onClick,
    "data-cy": !!showArrow && "HeaderSubMenuItem"
  }, !!icon && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    name: icon
  }), " ", /*#__PURE__*/_react.default.createElement("span", null, text), !!showArrow && !!items && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    name: "slim_arrow_down",
    size: "small"
  }));
};
exports.MenuLink = MenuLink;
var _default = exports.default = MenuLink;